/* eslint-disable @typescript-eslint/no-empty-function */
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CartSaleService } from '../../components-aux/cart/cart-sale.service';
import { MoneyBackSaleService } from './money-back-sale.service';
@Component({
  selector: 'pg-money-back-sale',
  templateUrl: './money-back-sale.component.html'
})
export class MoneyBackSaleComponent {
  moneyBack = null;
  amountSale: number;
  fg: FormGroup;
  constructor(
    private fb: FormBuilder,
    private cartSaleService: CartSaleService,
    private moneyBackSaleService: MoneyBackSaleService
  ) {}

  ngOnInit() {
    this.fg = this.fb.group({
      amountClient: [0.0, this.getValidator()]
    });
    this.cartSaleService.getData$().subscribe(() => {
      if (!this.cartSaleService.isCartEmpty()) {
        this.amountSale = this.cartSaleService.getTotalAmount();
      } else {
        this.amountSale = 0;
      }
      this.fg.get('amountClient').setValidators(this.getValidator());
      this.fg.setValue({
        amountClient: this.amountSale
      })
      this.moneyBackSaleService.setData({
        amountPaid: this.amountSale,
        moneyBack: 0
      });
      this.moneyBack = this.fg.get('amountClient').value - this.amountSale;
    });

    this.fg.get('amountClient').valueChanges.subscribe((value) => {
      this.moneyBack = value - this.amountSale;
      this.moneyBackSaleService.setData({
        amountPaid: value,
        moneyBack: this.moneyBack
      });
    });
  }

  getValidator() {
    return [Validators.required, Validators.min(this.amountSale)];
  }
}
